import { render, staticRenderFns } from "./IconTypeformEmail.vue?vue&type=template&id=8ac1b3e6&"
import script from "./IconTypeformEmail.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports